export default __webpack_public_path__ + "static/media/Aditya Kumar Pattnaik, Member, NIBA Alumni Association.f14b138e.jpg";